import React, { useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
//primereact
import { BreadCrumb } from "primereact/breadcrumb";
import { TabPanel, TabView } from "primereact/tabview";
//components
import Panel from "../../../../components/panel/panel";
import Variables from "./Variables";
import Contracts from "./Contracts";
import Test from "./Test";
import usePermission from "../../../../hooks/usePermission";

const ModelContracts = () => {
  const { id } = useParams();
  const { state } = useLocation();
  const [activeIndex, setActiveIndex] = useState(0);

  usePermission("109");

  const items = [
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Configurações do Empreendimento
        </Link>
      ),
    },
    {
      template: () => (
        <Link
          to={`/enterpriseSettings/modelContracts/${id}`}
          state={{ name: state ? state.name : "Empreendimento" }}
          className="p-breadcrumb-link"
        >
          Modelos de Contrato
        </Link>
      ),
    },
  ];
  const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };

  return (
    <>
      <BreadCrumb
        model={items}
        home={home}
        style={{
          background: "transparent",
          border: "none",
          fontSize: "16px",
        }}
      />
      <Panel>
        <div className="d-flex justify-content-between">
          <h4 className="mt-3">Modelos de Contrato</h4>
        </div>
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
          scrollable
          className="meu-tabview pt-3"
        >
          {/* <TabPanel
            header="Proposta de Compra"
            leftIcon="fa-solid fa-hand-holding-dollar mx-2"
          >
            <Contracts type={"proposta_compra"} />
          </TabPanel> */}
          <TabPanel header="Contrato" leftIcon="fa-solid fa-file-contract mx-2">
            <Contracts type={"contrato"} />
          </TabPanel>
          <TabPanel
            header="Renegociação"
            leftIcon="fa-solid fa-arrows-rotate mx-2"
          >
            <Contracts type={"renegociacao"} />
          </TabPanel>
          <TabPanel
            header="Cessão"
            leftIcon="fa-solid fa-arrow-right-arrow-left mx-2"
          >
            <Contracts type={"cessao"} />
          </TabPanel>
          <TabPanel header="Distrato" leftIcon="fa-solid fa-ban mx-2">
            <Contracts type={"distrato"} />
          </TabPanel>
          <TabPanel
            header="Termo de Quitação"
            leftIcon="fa-solid fa-handshake mx-2"
          >
            <Contracts type={"termo_quitacao"} />
          </TabPanel>
          {/* <TabPanel header="Variáveis" leftIcon="fa-solid fa-at mx-2">
            <Variables />
          </TabPanel> */}
        </TabView>
      </Panel>
    </>
  );
};

export default ModelContracts;
